<script setup lang="ts">
defineProps<{
  label?: string
  image?: string
  icon?: any
  as?: string
  href?: string
  highlighted?: boolean
  loading?: 'lazy' | 'eager'
}>()

</script>

<template>
  <li class="list-item">
    <component
      :is="href ? 'a' : as ?? 'div'"
      class="block w-full group"
      :href="href"
    >
      <div
        class="w-full flex items-center gap-2.5 bg-white hover:bg-surface-blue rounded-v2sm p-2"
        :class="highlighted ? 'bg-surface-blue' : ''"
        style="min-height: 58px;"
      >
        <slot v-if="image" name="image" :image="image">
          <img
            :src="image"
            :loading="loading"
            class="rounded-lg list-image"
            width="42"
            height="42"
          >
        </slot>
        <div
          v-else-if="icon"
          class="flex items-center justify-center bg-surface-grey rounded-lg text-v2-tertiary"
          style="padding: 9px;"
        >
          <GIcon :icon="icon" class="text-v2-tertiary" size="lg"/>
        </div>
        <div
          class="text-sm font-medium text-navy no-underline flex-1 flex items-center"
        >
          <slot>
            {{ label }}
          </slot>
        </div>
        <slot name="addonRight"/>
      </div>
    </component>
  </li>
</template>
